import React from 'react';
import Layout from './components/Layout';
import Home from './components/Home';
import Login from './components/Login';
import './custom.css'
import 'rc-time-picker/assets/index.css';
import { Route, Switch } from 'react-router-dom';
import { AuthProvider, useAuth } from './Services/AuthContext';
import NewCharterRequest from './components/Pages/NewCharterRequest';
import ManageClients from './components/EntityList/ManageClients';
import ManageSuppliers from './components/EntityList/ManageSuppliers';
import ManageWorkflow from './components/EntityList/ManageWorkflow';
import RespondToInvite from './components/Pages/LoginPanels/RespondToInvite';
import Me from './components/Pages/Me';
import { inviteAdminShapeYup, inviteClientDepartmentShapeYup, inviteClientShapeYup, inviteClientStaffShapeYup, inviteSupplierShapeYup, inviteCharterAdminShapeYup } from './utils/YupShapes';
import { authEndpoints } from './utils/Constants';
import ClientDetail from './components/Editors/ClientDetail';
import ClientStaffDetail from "./components/Editors/ClientStaffDetail";
import ClientDepartmentDetail from './components/Editors/ClientDepartmentDetail';
import Supplier from './components/Editors/Supplier';
import { AlertProvider } from './Services/AlertContext';
import SupplierAircraftList from './components/EntityList/SupplierAircraftList';
import BidHistory from './components/EntityList/BidHistory';
import CharterRequestsSupplier from './components/EntityList/CharterRequestsSupplier';
import CharterShares from './components/EntityList/CharterShares';
import ClientDepartmentList from './components/EntityList/ClientDepartmentList';
import ClientStaffList from './components/EntityList/ClientStaffList';
import ManageAdmins from './components/EntityList/ManageAdmins';
import ManageCharterAdmins from './components/EntityList/ManageCharterAdmins';
import AdminDetail from './components/Editors/AdminDetail';
import ResetPassword from './components/Pages/LoginPanels/ResetPassword';
import ConfirmEmail from './components/Pages/LoginPanels/ConfirmEmail';
import ManageMessaging from './components/EntityList/ManageMessaging'
import SupplierDocumentList from './components/EntityList/SupplierDocumentList';
import {
    AdminMessageLog, ClientMessageLog,
    ClientDepartmentMessageLog, ClientStaffMessageLog,
    SupplierMessageLog
} from './components/EntityList/ViewMessageLog';

const AppRoute = () => {
    const [auth] = useAuth();
    const loggedIn = auth.jwt;
    const registers = {
        admin:
        {
            getUrl: authEndpoints.tryAcceptAdmin,
            acceptUrl: authEndpoints.acceptAdmin,
            validation: inviteAdminShapeYup,
            editor: <AdminDetail invite />,
            testurl: '',
        },
        client:
        {
            getUrl: authEndpoints.tryAcceptClient,
            acceptUrl: authEndpoints.acceptClient,
            validation: inviteClientShapeYup,
            editor: <ClientDetail invite />,
            testurl
                : 'https://localhost:44327/clientInvite/'
        },
        clientDepartment:
        {
            getUrl: authEndpoints.tryAcceptClientDepartment,
            acceptUrl: authEndpoints.acceptClientDepartment,
            validation: inviteClientDepartmentShapeYup,
            editor: <ClientDepartmentDetail invite />,
            testurl: 'https://localhost:44327/clientDepartmentInvite/'
        },
        clientStaff:
        {
            getUrl: authEndpoints.tryAcceptClientStaff,
            acceptUrl: authEndpoints.acceptClientStaff,
            confirmEmail: authEndpoints.confirmClientStaff,
            validation: inviteClientStaffShapeYup,
            editor: <ClientStaffDetail invite />,
            testurl: 'https://localhost:44327/clientStaffInvite/9B98E44F-0472-492D-9D6F-0FFE5C372C09'
        },
        charterAdmin:
        {
            getUrl: authEndpoints.tryAcceptCharterAdmin,
            acceptUrl: authEndpoints.acceptCharterAdmin,
            confirmEmail: authEndpoints.confirmCharterAdmin,
            validation: inviteCharterAdminShapeYup,
            editor: <ClientStaffDetail invite />,
            testurl: 'https://localhost:44327/clientStaffInvite/9B98E44F-0472-492D-9D6F-0FFE5C372C09'
        },
        supplier:
        {
            getUrl: authEndpoints.tryAcceptSupplier,
            acceptUrl: authEndpoints.acceptSupplier,
            validation: inviteSupplierShapeYup,
            confirmEmail: authEndpoints.confirmSupplier,
            editor: <Supplier invite />,
            testurl: 'https://localhost:44327/supplierInvite/'
        },
    };

    return loggedIn ? (auth.terms ? <Switch>
        <Route path='/newCharterRequest' component={NewCharterRequest} />
        <Route path='/resetPassword/:id/:item' component={ResetPassword} />
        <Route path='/clientInvitation/:id' render={() => <RespondToInvite {...registers.client} />} />
        <Route path='/clientAdminInvitation/:id' render={() => <RespondToInvite {...registers.admin} />} />
        <Route path='/charterAdminInvitation/:id' render={() => <RespondToInvite {...registers.charterAdmin} />} />
        <Route path='/clientDepartmentInvitation/:id' render={() => <RespondToInvite {...registers.clientDepartment} />} />
        <Route path='/clientStaffInvitation/:id' render={() => <RespondToInvite {...registers.clientStaff} />} />
        <Route path='/supplierInvitation/:id' render={() => <RespondToInvite {...registers.supplier} />} />
        <Route path='/confirmEmailClient/:id/*' render={() => <ConfirmEmail detail={registers.clientStaff} />} />
        <Route path='/confirmEmailSupplier/:id/*' render={() => <ConfirmEmail detail={registers.supplier} />} />

        <Route path='/charterRequests/:list/:activeKey' render={() => <CharterRequestsSupplier area='' route='/charterRequests' />} />
        <Route path='/charterRequests/:list' render={() => <CharterRequestsSupplier area='' route='/charterRequests' />} />
        <Route path='/charterRequests' render={() => <CharterRequestsSupplier area='' route='/charterRequests' />} />
        <Route path='/charterShares/:list/:activeKey' render={() => <CharterShares area='' route='/charterShares' />} />
        <Route path='/charterShares/:list' render={() => <CharterShares area='' route='/charterShares' />} />
        <Route path='/charterShares' render={() => <CharterShares area='' route='/charterShares' />} />

        {auth?.role === 'Admin' ? <Route path='/manageStaff' render={() => <ClientStaffList hideAction client route='/manageStaff' />} /> : null}
        {auth?.role === 'Admin' ? <Route path='/manageDepartments' render={() => <ClientDepartmentList hideActions client route='/manageDepartments' />} /> : null}


        {auth?.role === 'Admin' ? <Route path='/manageSuppliers' render={() =>
            <ManageSuppliers route="/manageSuppliers" />
        } /> : null}
        {auth?.role === 'Admin' ? <Route path='/manageClients/:clientList' render={() =>
            <ManageClients route='/manageClients' />
        } /> : null}
        {auth?.role === 'CharterAdmin' ? <Route path='/manageCharterAdmins/:clientList' render={() =>
            <ManageClients route='/manageCharterAdmins' />
        } /> : null}
        {auth?.role === 'Client' ? <Route path='/manageDepartments' render={() =>
            <ClientDepartmentList route='/manageDepartments' />
        } /> : null}
        {auth?.role === 'Client' ? <Route path='/manageStaff' render={() =>
            <ClientStaffList route='/manageStaff' />
        } /> : null}

        {auth?.role === 'Admin' ? <Route path='/manageAdmins/:adminId' render={() => <ManageAdmins route='/manageAdmins' />} /> : null}
        {auth?.role === 'Admin' ? <Route path='/manageAdmins' exact render={() => <ManageAdmins route='/manageAdmins' />} /> : null}
        {false || auth?.role === 'Admin' ? <Route path='/manageCharterAdmins' exact render={() => <ManageCharterAdmins route='/manageCharterAdmins' />} /> : null}
        {auth?.role === 'Admin' && auth?.managesWorkflow ? <Route path='/manageWorkflow/:choice/:entity/:id' component={ManageWorkflow} /> : null}
        {auth?.role === 'Admin' && auth?.managesWorkflow ? <Route path='/manageWorkflow/:choice/:entity' component={ManageWorkflow} /> : null}
        {auth?.role === 'Admin' && auth?.managesWorkflow ? <Route path='/manageWorkflow/:choice/new/:role/:state' component={ManageWorkflow} /> : null}
        {auth?.role === 'Admin' && auth?.managesWorkflow ? <Route path='/manageWorkflow/:choice/' component={ManageWorkflow} /> : null}
        {auth?.role === 'Admin' && auth?.managesWorkflow ? <Route path='/manageWorkflow' exact component={ManageWorkflow} /> : null}
        {auth?.role === 'Admin' && auth?.managesMessages ? <Route path='/manageMessaging/:type/:eventId' component={ManageMessaging} /> : null}
        {auth?.role === 'Admin' && auth?.managesMessages ? <Route path='/manageMessaging/:type' component={ManageMessaging} /> : null}
        {auth?.role === 'Admin' && auth?.managesMessages ? <Route path='/manageMessaging/' exact component={ManageMessaging} /> : null}

        {auth?.role === 'Admin' ? <Route path='/messageLog/:messageId' render={() => <AdminMessageLog route='/messageLog' />} /> : null}
        {auth?.role === 'Admin' ? <Route path='/messageLog' render={() => <AdminMessageLog route='/messageLog' />} /> : null}
        {auth?.clientId ? <Route path='/messageLog/:messageId' render={() => <ClientMessageLog route='/messageLog' clientId={auth?.clientId} />} /> : null}
        {auth?.clientId ? <Route path='/messageLog' render={() => <ClientMessageLog route='/messageLog' clientId={auth?.clientId} />} /> : null}
        {auth?.clientDepartmentId ? <Route path='/messageLog/:messageId' render={() => <ClientDepartmentMessageLog route='/messageLog' clientDepartmentId={auth?.clientDepartmentId} />} /> : null}
        {auth?.clientDepartmentId ? <Route path='/messageLog' render={() => <ClientDepartmentMessageLog route='/messageLog' clientDepartmentId={auth?.clientDepartmentId} />} /> : null}

        {auth?.clientStaffId ? <Route path='/messageLog/:messageId' render={() => <ClientStaffMessageLog route='/messageLog' clientStaffId={auth?.clientStaffId} />} /> : null}
        {auth?.clientStaffId ? <Route path='/messageLog' render={() => <ClientStaffMessageLog route='/messageLog' clientStaffId={auth?.clientStaffId} />} /> : null}
        {auth?.supplierId ? <Route path='/messageLog/:messageId' render={() => <SupplierMessageLog route='/messageLog' supplierId={auth?.supplierId} />} /> : null}
        {auth?.supplierId ? <Route path='/messageLog' render={() => <SupplierMessageLog route='/messageLog' supplierId={auth?.supplierId} />} /> : null}

        {auth?.supplierId ? <Route path='/documents' render={() => <SupplierDocumentList route='/documents' supplierId={auth?.supplierId} />} /> : null}


        {auth?.supplierId || auth?.role === 'Admin' ? <Route path='/aircraft' render={() => <SupplierAircraftList route="/aircraft" />} /> : null}
        {auth?.supplierId || auth?.role === 'Admin' ? <Route path='/bid/:itemId/:imageId' render={() => <BidHistory route="/bids" />} /> : null}
        {auth?.supplierId || auth?.role === 'Admin' ? <Route path='/bids/:itemId' render={() => <BidHistory route="/bids" />} /> : null}
        {auth?.supplierId || auth?.role === 'Admin' ? <Route path='/bids' render={() => <BidHistory route="/bids" />} /> : null}
        <Route path='/me' render={() => <Me route="/me" />} />

        <Route path='/login' component={Login} />
        <Route path='*' component={Home} />
    </Switch> : <Route path='*' component={Login} />) : <Switch>


        <Route path='/confirmEmailClient/:id/*' render={() => <ConfirmEmail detail={registers.clientStaff} />} />
        <Route path='/confirmEmailSupplier/:id/*' render={() => <ConfirmEmail detail={registers.supplier} />} />
        <Route path='/resetPassword/:id/:item' component={ResetPassword} />
        <Route path='/clientAdminInvitation/:id' render={() => <RespondToInvite {...registers.admin} />} />
        <Route path='/clientInvitation/:id' render={() => <RespondToInvite {...registers.client} />} />
        <Route path='/clientDepartmentInvitation/:id' render={() => <RespondToInvite {...registers.clientDepartment} />} />
        <Route path='/clientStaffInvitation/:id' render={() => <RespondToInvite {...registers.clientStaff} />} />
        <Route path='/supplierInvitation/:id' render={() => <RespondToInvite {...registers.supplier} />} />
        <Route path='*' component={Login} /> )
    </Switch>
};
const App = () => {

    return (

        <AlertProvider>
            <AuthProvider>
                <Layout>
                    <AppRoute />
                </Layout>
            </AuthProvider>
        </AlertProvider>
    );


};
export default App;
